(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('createProxyClass', createProxyClass);

    var forEach = angular.forEach,
        copy = angular.copy,
        isObject = angular.isObject,
        noop = angular.noop;

    function createProxyClass() {
        return function createProxyClass(template) {

            function Proxy(data) {
                if (!(this instanceof Proxy))
                    return new Proxy(data);
                Object.defineProperties(this, {
                    _data: { writable: true, value: data },
                    _pristine: { writable: true, value: data },
                    _handlers: { writeable: true, value: {} }
                });
                this.onInit();
            }

            Proxy.prototype = {
                edit: function $edit() {
                    if (!this.isEditing)
                        this._data = copy(this._pristine);
                },
                rollback: function $rollback() {
                    if (this.isEditing)
                        this._data = this._pristine;
                },
                commit: function $commit(data) {
                    if (this.isEditing)
                        this._data = copy(data || this._data, this._pristine);
                },
                toJSON: function () {
                    return this._data;
                },
                onInit: noop
            };

            Object.defineProperty(Proxy.prototype, 'isEditing', { get: function () { return this._data !== this._pristine; } });
            forEach(template, addProperty, this);

            function addProperty(value, key) {
                Object.defineProperty(Proxy.prototype, key, { get: get, set: set, enumerable: true, configurable: true });
                function get() { return this._data[key]; }
                function set(value) { this._data[key] = value; }
            }

            return Proxy;
        }
    }
})();